<template>
    <div>
        <el-row class="">
            <el-col>
                <div class="table-grd">
                    <div class="header">
                        <h1>{{ $t('Archive') }}</h1>
                        <ul class="icon-list">
                            <li><a href="javascript:void(0)" :title="$t('Search')" v-collapse-toggle="'toggle_first'"><i class="icon-advance-search"></i></a></li>
                        </ul>
                    </div>
                    <v-collapse-group ref="group1">
                        <v-collapse-wrapper ref="toggle_second">
                            <div class="my-content table-desc">
                                <v-collapse-wrapper ref="toggle_first" class="search-data">
                                    <div class="my-content" v-collapse-content>
                                        <el-form :model="filterData" ref="filterData" :inline="true">
                                            <div class="bottom-dev">
                                                <el-col :xs="12" :sm="7" :md="7" :lg="4" :xl="4">
                                                    <el-form-item class="all-select">
                                                        <el-select v-model="selectedColumns" multiple placeholder="Columns" size="medium" collapse-tags>
                                                            <el-option v-for="(item) in column_name" :label="item.label" :value="item.value" :key="item.value"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :xs="12" :sm="5" :md="4" :lg="3" :xl="3">
                                                    <el-form-item prop="case_title">
                                                        <el-input v-model="filterData.case_title" :placeholder="$t('Case')" size="medium" @keyup.enter.native="handleCurrentChange"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <span v-if="$store.state.config.user.fachstellen_slug || fachstellen_slug"></span>
                                                <el-col :xs="12" :sm="6" :md="5" :lg="3" :xl="3" v-else>
                                                    <el-form-item prop="fachstellen_slug">
                                                        <el-select v-model="filterData.fachstellen_slug" :placeholder="$t('Fachstellen')" size="medium" @change="getAllPatenkinder" filterable>
                                                            <el-option v-for="(item) in fachstellenList.data" :label="item.display_name" :key="item.slug" :value="item.slug"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :xs="12" :sm="6" :md="4" :lg="3" :xl="3">
                                                    <el-form-item prop="patenkinder_slug">
                                                        <el-select v-model="filterData.patenkinder_slug" :placeholder="$t('Godchild')" size="medium" filterable>
                                                            <el-option v-for="(item) in patenkinderList.data" :label="item.display_name" :key="item.slug" :value="item.slug"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :xs="12" :sm="6" :md="4" :lg="3" :xl="3">
                                                    <el-form-item prop="status">
                                                        <el-select v-model="filterData.status" :placeholder="$t('Status')" size="medium" filterable>
                                                            <el-option v-for="(item, key) in caseStages" :label="$t(item)" :key="key" :value="key"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :xs="24" :sm="10" :md="8" :lg="6" :xl="4">
                                                    <div class="el-form-item">
                                                        <el-button type="primary" icon="el-icon-search" @click="handleCurrentChange" size="small">{{
                                                            $t('Search') }}</el-button>
                                                        <el-button type="cancel" @click="resetForm('filterData')" size="small">{{
                                                            $t('Reset') }}</el-button>
                                                    </div>
                                                </el-col>
                                            </div>
                                        </el-form>
                                    </div>
                                </v-collapse-wrapper>
                                <el-table :data="pastCases.data" @sort-change="handleSortChange" fit highlight-current-row key='aTable'>
                                    <el-table-column :label="$t('No.')" type="index" :index="indexMethod" width="100" fixed></el-table-column>
                                    <el-table-column show-overflow-tooltip :label="$t('Case Title')" sortable="custom" prop="case_title" width="400">
                                        <template slot-scope="scope">
                                            <router-link :to="{name: 'CaseVoting',params: {id: scope.row.id}}">
                                                {{ scope.row.case_title }}</router-link>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Fachstellen Name')" sortable="custom" prop="fachstellen_name" width="300">
                                        <template slot-scope="scope">
                                            <router-link :to="{name: 'FachstellenDashboard', params: {'fachstellen_slug': scope.row.fachstellen_slug }}" v-if="$store.getters.getConfig('has_permissions').includes('fachstellens-index')">
                                                {{ scope.row.fachstellen_name }}</router-link>
                                            <span v-else>{{ scope.row.fachstellen_name }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Godchild')" sortable="custom" prop="patenkinder_name" width="250">
                                    </el-table-column>
                                    <el-table-column :label="$t('Status')" sortable="custom" prop="status" width="180">
                                        <template slot-scope="scope">
                                            <el-tag size="mini" :type="getStatusType(scope.row.status_key)">
                                                {{ $t(scope.row.status_key) }}
                                            </el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Votes')" width="150">
                                        <template slot-scope="scope">
                                            <el-tag size="mini" type="success" class="vote-status-thumb">{{
                                                scope.row.case_up_votes }} <i class="icon-up-votes"></i> </el-tag>
                                            <el-tag size="mini" type="danger" class="vote-status-thumb">{{
                                                scope.row.case_down_votes }} <i class="icon-down-votes"></i></el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Created at')" sortable="custom" prop="created_at" width="250">
                                        <template slot-scope="scope">
                                            <span v-date-time-format="scope.row.created_at"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Modified at')" sortable="custom" prop="updated_at" width="250">
                                        <template slot-scope="scope">
                                            <span v-date-time-format="scope.row.updated_at"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column min-width="10"></el-table-column>
                                </el-table>
                                <el-pagination v-if="pastCases.meta.total" background @size-change="handleSizeChange" @current-change="getPastCases()" :current-page.sync="filterData.page" :page-sizes="[6, 12, 24, 66, 111]" :page-size="filterData.pageLength" layout="sizes, slot, ->, prev, pager, next" :total="pastCases.meta.total">
                                    <template>
                                        <span class="page-no">{{ $t('Showing out of records',{'0': pastCases.data.length,
                                            '1': pastCases.meta.total}) }}</span>
                                    </template>
                                </el-pagination>
                            </div>
                        </v-collapse-wrapper>
                    </v-collapse-group>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        props: {
            organization_slug: String,
            fachstellen_slug: String,
            club_slug: String
        },
        data() {
            return {
                filterData: {
                    page: 1,
                    pageLength: process.env.KIPAKI_pageLength,
                    sortBy: "id",
                    order: "desc",
                    organization_slug: this.$store.state.config.user.organization_slug || this.organization_slug,
                    fachstellen_slug: this.$store.state.config.user.fachstellen_slug || this.fachstellen_slug,
                    club_slug: this.$store.state.config.user.club_slug || this.club_slug,
                    patenkinder_slug: null,
                    status: null
                },
                pastCases: {
                    meta: {},
                    data: []
                },
                fachstellenList: {},
                patenkinderList: {},
                caseStages: {},
                column_name: [{
                        value: "case_title",
                        label: this.$t("Case Title")
                    },
                    {
                        value: "fachstellen_name",
                        label: this.$t("Fachstellen")
                    },
                    {
                        value: "patenkinder_name",
                        label: this.$t("Godchild")
                    },
                    {
                        value: 'status',
                        label: this.$t("Status")
                    },
                    {
                        value: 'votes',
                        label: this.$t("Votes")
                    },
                    {
                        value: 'created_at',
                        label: this.$t('Created at')
                    },
                    {
                        value: 'updated_at',
                        label: this.$t('Modified at')
                    },
                ],
                selectedColumns: [],
                filterParams: {}
            };
        },
        mounted() {
            this.filterParams = Object.assign({}, this.filterData);
            this.selectedColumns = this.column_name.map(a => a.value)
            this.getPastCases();
            this.getCaseStages();
            this.getAllFachstellen();
            this.getAllPatenkinder();
        },
        methods: {
            getStatusType(status_key) {
                var statusType = '';
                switch (status_key) {
                    case 'stage_1':
                        statusType = 'info';
                        break;
                    case 'stage_2':
                        statusType = 'warning'
                        break;
                    case 'stage_3':
                        statusType = '';
                        break;
                    case 'donated':
                        statusType = 'success';
                        break;
                    default:
                        statusType = 'danger';
                }
                return statusType;
            },
            getPastCases() {
                request({
                    url: "get-pastCase",
                    method: "get",
                    params: this.filterData
                }).then(response => {
                    this.pastCases = response.data;
                    setTimeout(() => {
                        $('table .el-tooltip').removeClass('el-tooltip');
                    });
                });
            },
            getCaseStages() {
                request({
                    url: "get-all-case-status",
                    method: "get"
                }).then(response => {
                    this.caseStages = response.data.data;
                });
            },
            handleCurrentChange(event) {
                this.filterData.page = 1;
                this.getPastCases(this.filterData.current_page);
            },
            handleSizeChange(event) {
                this.filterData.pageLength = event;
                this.getPastCases();
            },
            handleSortChange(event) {
                this.filterData.sortBy = event.prop;
                if (event.order === "ascending") this.filterData.order = "asc";
                else if (event.order === "descending") this.filterData.order = "desc";
                else {
                    this.filterData.sortBy = "id";
                    this.filterData.order = "desc";
                }
                this.getPastCases();
            },
            indexMethod(index) {
                return index + this.filterData.pageLength * this.filterData.page - this.filterData.pageLength + 1
            },
            getAllFachstellen() {
                request({
                    url: "get-all-fachstellen",
                    method: "get",
                    params: {
                        organization_slug: this.filterData.organization_slug,
                        club_slug: this.filterData.club_slug
                    }
                }).then(response => {
                    this.fachstellenList = response.data;
                });
            },
            getAllPatenkinder() {
                request({
                    url: "get-all-patenkinder",
                    method: "get",
                    params: {
                        fachstellen_slug: this.filterData.fachstellen_slug,
                        organization_slug: this.filterData.organization_slug,
                        club_slug: this.filterData.club_slug
                    }
                }).then(response => {
                    this.filterData.patenkinder_slug = null;
                    this.patenkinderList = response.data;
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.filterParams = Object.assign({}, this.filterData);
                this.getAllPatenkinder();
                this.getPastCases();
            },
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/Layout/Cases/PastCases.vue